<template>
  <router-link
    class="visa-video-item"
    :to="{ name: 'videoDetail', params: { id: videoInfo.id } }"
    target="_blank">
    <div class="hover-bg"></div>
    <div class="video-item">
      <img class="video-img" :src="videoInfo.cover"/>
      <div class="video-title">{{ videoInfo.title }}</div>
      <div class="bottom-info">
        <div class="learned-count">{{ formatViewecCount(videoInfo.hit) }}人学过</div>
        <div class="fill-space"></div>
        <div class="start-learn">开始学习</div>
      </div>
    </div>
  </router-link>
</template>

<script>

import knowledgeService from "../../../services/knowledge-service";

export default {
  name: 'visa-video-item',
  props: {
    videoInfo: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  methods: {
    formatViewecCount:knowledgeService.formatViewecCount,
    goToClassDetail(id) {
      this.$router.push({ name: 'videoDetail', params: { id } });
    }
  }
}
</script>

<style lang="less" scoped>
.visa-video-item {
  position: relative;
  width: 257px;
  margin-right: 30px;
  margin-bottom: 30px;
  cursor: pointer;
  &:nth-child(4n) {
    margin-right: 0;
  }
  .hover-bg {
    display: none;
    position: absolute;
    z-index: 1;
    left: -12px;
    top: -12px;
    width: 281px;
    height: 260px;
    transition: all .3s;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px -4px rgba(47, 51, 61, 0.24);
    border-radius: 2px;
  }
  &:hover {
    .hover-bg {
      display: flex;
    }
  }
  .video-item {
    background: #FFFFFF;
    border-radius: 2px;
    position: relative;
    z-index: 2;
    .video-img {
      width: 257px;
      height: 144px;
      background-color: gray;
    }
    .video-title {
      margin-top: 12px;
      font-size: 16px;
      font-weight: 500;
      color: #2F333D;
      line-height: 22px;
      height: 44px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .bottom-info {
      display: flex;
      align-items: center;
      margin-top: 12px;
      .learned-count {
        font-size: 14px;
        font-weight: 400;
        color: #91999F;
        line-height: 20px;
      }
      .fill-space {
        flex: 1;
      }
      .start-learn {
        font-size: 14px;
        font-weight: 500;
        color: #599FFF;
        line-height: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/academy/components/visa-video-item.vue